import React, {Component} from 'react'
import {withNamespaces} from 'react-i18next'
import withStyles from '@mui/styles/withStyles'
import {assign, flowRight as compose} from 'lodash'
import {promoMaterialTypes} from '@bdswiss/common-enums'
import {PROMO_MATERIALS_QUERY} from '../../../graphql/queries'
import {graphql, withApollo} from 'react-apollo'
import PromoMaterialLayout from './PromoMaterialLayout'

const styles = theme => ({})
class Logos extends Component {
  render() {
    const {promoMaterials, fetchMore, promoMaterialsCount, refetchPromoMaterials} = this.props
    return (
      <PromoMaterialLayout
        promoMaterials={promoMaterials}
        fetchMore={fetchMore}
        promoMaterialsCount = {promoMaterialsCount}
        type={promoMaterialTypes.logo.key}
        filterIds={[{id: 'size'}]}
        innerFilterIds={[{id: 'size'}]}
        refetchPromoMaterials={refetchPromoMaterials}
      />
    )
  }
}

export default compose(
  withStyles(styles, {withTheme: true}),
  withNamespaces(),
  withApollo,
  graphql(PROMO_MATERIALS_QUERY, {
    name: 'fetchPromoMaterials',
    options: () => ({
      fetchPolicy: 'network-only',
      variables: {
        type: promoMaterialTypes.logo.key,
        uniqueAssetName: true,
        limit: 5,
        offset: 0,
      }
    }),
    props: ({fetchPromoMaterials:{error, loading, promoMaterials, promoMaterialsCount, refetch, fetchMore}}) => ({
      loading,
      error,
      promoMaterials,
      promoMaterialsCount,
      refetchPromoMaterials: refetch,
      fetchMore: (variables) => fetchMore({
        variables,
        updateQuery: (prev, {variables, fetchMoreResult}) => {
          const {promoMaterials:prevPromoMaterials} = prev
          const {promoMaterials:nextPromoMaterials} = fetchMoreResult
          if (!fetchMoreResult || prevPromoMaterials?.length > variables?.offset) return prev
          return assign({}, prev, {promoMaterials: [...prevPromoMaterials, ...nextPromoMaterials]})
        }
      })
    }),
  }),
)(Logos)

